export const reinterpretUTCAsLocalDate = (dateString: string): Date | null => {
  if (!dateString) {
    return null;
  }

  const utcDate = new Date(dateString);
  if (Number.isNaN(utcDate.getTime())) {
    return null;
  }

  return new Date(
    utcDate.getUTCFullYear(),
    utcDate.getUTCMonth(),
    utcDate.getUTCDate()
  );
};
